import { Controller } from 'stimulus'
import { fetch } from 'shared/js/fetch'

export default class extends Controller {
  static targets = [ 'active', 'inactive', 'item' ]

  connect() {
    if (this.hasActiveTarget) {
      if (this.isActive()) {
        this.active()
      } else {
        this.inactive()
      }
    }
  }

  create(event) {
    event.preventDefault() // stop propagation

    fetch(this.path, { method: 'POST' }).then(response => {
      if (response.ok) {
        this.active()
        this.updateCount(count => count + 1)
      }
    })
  }

  destroy(event) {
    event.preventDefault() // stop propagation

    fetch(this.path, { method: 'DELETE' }).then(response => {
      if (response.ok) {
        if (this.hasActiveTarget) this.inactive()
        else this.itemTarget.remove()

        this.updateCount(count => count - 1)
      }
    })
  }

  active() {
    this.inactiveTarget.classList.add('hidden')
    this.activeTarget.classList.remove('hidden')
  }

  inactive() {
    this.activeTarget.classList.add('hidden')
    this.inactiveTarget.classList.remove('hidden')
  }

  updateCount(operation) {
    const count = operation(parseInt(this.counter.innerHTML))
    this.counter.innerHTML = count

    if (count > 0) this.counter.classList.remove('hidden')
    else           this.counter.classList.add('hidden')
  }

  isActive() {
    return this.data.get('active') == 'true'
  }

  get path() {
    return this.data.get('path')
  }

  get counter() {
    return document.getElementById('booklist-count')
  }
}
